import {
  ActionSlotDef,
  AgentEffectCommands,
  AgentIcon,
  FactionType,
  ResourceType,
  actionSlotRepository,
} from "~/business";
import { Resources } from "~/utils";

export const initActionSlots = () => {
  const {
    BeneGesserit,
    City,
    Emperor,
    Fremen,
    Landsraad,
    SpacingGuild,
    SpiceTrade,
  } = AgentIcon;

  const {
    spice,
    solaris,
    influencePoints,
    garnison,
    draw,
    drawIntrigue,
    water,
    mentat,
    takeSiege,
    buyWorker,
    buySpaceWarp,
    stealIntrigue,
    cause,
    and,
    or,
    trashCard,
    sellSpice,
    hasInfluenceLevel2,
    freighter,
    dreadnought,
    acquireTechTile,
    techNegociator,
  } = AgentEffectCommands;

  const actionSlotDefs: ActionSlotDef[] = [
    // desert
    {
      id: "Imperial Basin",
      agentIcon: SpiceTrade,
      effects: [spice(1)],
      isBattle: true,
      isHarvest: true,
      controlEffect: spice(1),
    },
    {
      id: "Hagga Basin",
      agentIcon: SpiceTrade,
      cost: Resources.fromRecord({
        [ResourceType.Water]: 1,
      }),
      effects: [spice(2)],
      isBattle: true,
      isHarvest: true,
    },
    {
      id: "The great flat",
      agentIcon: SpiceTrade,
      cost: Resources.fromRecord({
        [ResourceType.Water]: 2,
      }),
      effects: [spice(3)],
      isBattle: true,
      isHarvest: true,
    },

    // CHOM
    {
      id: "Secure contract",
      agentIcon: SpiceTrade,
      effects: [solaris(3)],
    },
    {
      id: "Sell melange",
      agentIcon: SpiceTrade,
      effects: [sellSpice],
    },

    // landsraad
    {
      id: "Hall of Oratory",
      agentIcon: Landsraad,
      effects: [influencePoints(1), garnison(1)],
    },
    {
      id: "Mentat",
      agentIcon: Landsraad,
      cost: Resources.fromRecord({
        [ResourceType.Solaris]: 2,
      }),
      effects: [draw, mentat],
    },
    {
      id: "Rally Troops",
      agentIcon: Landsraad,
      cost: Resources.fromRecord({
        [ResourceType.Solaris]: 4,
      }),
      effects: [garnison(4)],
    },
    {
      id: "High Council",
      agentIcon: Landsraad,
      cost: Resources.fromRecord({
        [ResourceType.Solaris]: 5,
      }),
      effects: [takeSiege],
    },
    {
      id: "Swordmaster",
      agentIcon: Landsraad,
      cost: Resources.fromRecord({
        [ResourceType.Solaris]: 8,
      }),
      effects: [buyWorker],
    },

    // City
    {
      id: "Arrakeen",
      agentIcon: City,
      effects: [draw, garnison(1)],
      isBattle: true,
      controlEffect: solaris(1),
    },
    {
      id: "Carthag",
      agentIcon: City,
      effects: [drawIntrigue, garnison(1)],
      isBattle: true,
      controlEffect: solaris(1),
    },
    {
      id: "Research station",
      agentIcon: City,
      cost: Resources.fromRecord({
        [ResourceType.Water]: 2,
      }),
      effects: [draw, draw, draw],
      isBattle: true,
    },
    {
      id: "Sietch Tabr",
      agentIcon: City,
      effects: [
        cause(hasInfluenceLevel2(FactionType.Fremen)).effect(
          and([water(1), garnison(1)])
        ),
      ],
      isBattle: true,
    },

    // emperor
    {
      id: "Conspire",
      agentIcon: Emperor,
      cost: Resources.fromRecord({
        [ResourceType.Spice]: 4,
      }),
      effects: [solaris(5), garnison(4)],
    },
    {
      id: "Wealth",
      agentIcon: Emperor,
      effects: [solaris(2)],
    },
    // guild
    {
      id: "Heighliner",
      agentIcon: SpacingGuild,
      cost: Resources.fromRecord({
        [ResourceType.Spice]: 6,
      }),
      effects: [garnison(5), water(2)],
      isBattle: true,
    },
    {
      id: "Foldspace",
      agentIcon: SpacingGuild,
      effects: [buySpaceWarp],
    },
    // bene gesserit
    {
      id: "Selective Breeding",
      agentIcon: BeneGesserit,
      cost: Resources.fromRecord({
        [ResourceType.Spice]: 2,
      }),
      effects: [cause(trashCard).effect(and([draw, draw]))],
    },
    {
      id: "Secrets",
      agentIcon: BeneGesserit,
      effects: [drawIntrigue, stealIntrigue],
    },

    // Fremen
    {
      id: "Hardy Warriors",
      agentIcon: Fremen,
      cost: Resources.fromRecord({
        [ResourceType.Water]: 1,
      }),
      effects: [garnison(2)],
      isBattle: true,
    },
    {
      id: "Stillsuits",
      agentIcon: Fremen,
      effects: [water(1)],
      isBattle: true,
    },
  ];

  const ixSlots: ActionSlotDef[] = [
    {
      id: "Smuggling",
      agentIcon: SpiceTrade,
      effects: [solaris(1), freighter],
    },
    {
      id: "Interstellar Shipping",
      agentIcon: SpiceTrade,
      effects: [
        cause(hasInfluenceLevel2(FactionType.Guild)).effect(
          and([freighter, freighter])
        ),
      ],
    },
    {
      id: "Dreadnought",
      agentIcon: Landsraad,
      cost: Resources.fromRecord({
        [ResourceType.Solaris]: 3,
      }),
      effects: [dreadnought, acquireTechTile({})],
    },
    {
      id: "Tech negociation",
      agentIcon: Landsraad,
      effects: [
        influencePoints(1),
        or([acquireTechTile({ discount: 1 }), techNegociator]),
      ],
    },
  ];

  actionSlotRepository.addAll(actionSlotDefs);
  actionSlotRepository.addAll(
    ixSlots.map((slot) => ({ ...slot, extension: "Ix" }))
  );
  console.debug("init action slots");
};
